import { GET_TRACKING_ERROR, GET_TRACKING_REQUEST, GET_TRACKING_SUCCESS } from "../actions/types";

export default function (state = [], action) {
	const { type, payload } = action;
	switch (type) {
		case GET_TRACKING_REQUEST:
			return {
				loading: true,
			};
		case GET_TRACKING_SUCCESS:
			return {
				...state,
				loading: false,
				payload,
			};
		case GET_TRACKING_ERROR:
			return {
				...state,
				loading: false,
				payload,
			};
		default:
			return state;
	}
}